const DEFAULT_CHUNK_SIZE = 40;

/**
 * Default limit of collection source items
 */
export const DEFAULT_CHUNK_SIZE__COLLECTION_LIMIT = DEFAULT_CHUNK_SIZE;

/**
 * Default count of items to fetch when previewing a page
 */
export const DEFAULT_CHUNK_SIZE__ITEMS_COUNT = DEFAULT_CHUNK_SIZE;

/**
 * Default count of masterIds to fetch at a time in the context of duplicate resolutions
 */
export const DEFAULT_CHUNK_SIZE__MASTER_ID_MAPPINGS = DEFAULT_CHUNK_SIZE;

/**
 * Default title search size
 */
export const DEFAULT_CHUNK_SIZE__SEARCH = 100;

/**
 * Default chunk size when fetching episode list
 */
export const DEFAULT_CHUNK_SIZE__EPISODES = 1000;

/**
 * Default title search size
 */
export const DEFAULT_CHUNK_SIZE__TITLE_POPULARITY = 10;
